import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css`
  .terminate-car-modal {
    width: 380px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .terminate-car-modal-inputs {
    width: 100%;
    padding-bottom: 16px;
  }
  .terminate-car-wrapper,
  .reason-selector-wrapper {
    margin-bottom: 8px;
  }
  .terminate-car-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
    background-color: red;
  }
  .terminate-car-modal :global(.submit-button:hover) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
    background-color: red;
  }
  .terminate-car-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .terminate-car-modal :global(.cancel-button:hover) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
